import { Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
  BalancePool,
  BalancePoolCategory,
} from '~/scenes/MyWorkspace/components/Widgets/components/MyDataWidget/components/Content/useVacationBalances';

import { useSxStyles } from './useStyles';

type PropsType = {
  balancePool: BalancePool;
};

export const SelectedAbsenceBalance = (props: PropsType) => {
  const { balancePool } = props;

  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  if (!balancePool) {
    return <></>;
  }

  const BalanceInfo = (balanceProps: { title: string; balance: number }) => {
    const { title, balance } = balanceProps;

    return (
      <Typography variant={'caption'} sx={sxStyles.root}>
        {`${title}: ${t('NDays', { days: balance })}`}
      </Typography>
    );
  };

  switch (balancePool.category) {
    case BalancePoolCategory.VacationBalance:
    case BalancePoolCategory.ExtraVacationBalance:
    case BalancePoolCategory.VacationBankBalance:
    case BalancePoolCategory.YearlyVacationBalance:
      return (
        <BalanceInfo
          title={t('remainingBalance')}
          balance={balancePool.balance}
        />
      );
    default:
      return <></>;
  }
};
